module.exports = __webpack_public_path__ + "static/media/3 location urban sidewalk street architecture storefront white car trees 1280x2276.60635df4.webp";